if (!window.editorialVideoTutorialBound) {
  window.editorialVideoTutorialBound = true;

  const getMedia = (video) => video.closest('[data-tutorial-video]');
  const disableNativeControls = (container) => {
    container.querySelectorAll('[data-tutorial-video] video').forEach((video) => {
      video.controls = false;
    });
  };

  disableNativeControls(document);
  document.addEventListener('shopify:section:load', (event) => disableNativeControls(event.target));

  document.addEventListener('click', (event) => {
    const playButton = event.target.closest('[data-tutorial-play]');

    if (playButton) {
      const media = playButton.closest('[data-tutorial-video]');
      const video = media?.querySelector('video');
      if (!video) return;

      event.preventDefault();
      video.controls = false;
      video.play().catch(() => media.classList.remove('is-playing'));
      return;
    }

    const video = event.target.closest('[data-tutorial-video] video');
    if (!video || video.paused) return;

    event.preventDefault();
    video.pause();
  });

  document.addEventListener(
    'play',
    (event) => {
      const video = event.target;
      if (!(video instanceof HTMLVideoElement)) return;

      const media = getMedia(video);
      if (!media) return;

      video.controls = false;
      media.classList.add('is-playing');
    },
    true
  );

  document.addEventListener(
    'pause',
    (event) => {
      const video = event.target;
      if (!(video instanceof HTMLVideoElement)) return;

      getMedia(video)?.classList.remove('is-playing');
    },
    true
  );

  document.addEventListener(
    'ended',
    (event) => {
      const video = event.target;
      if (!(video instanceof HTMLVideoElement)) return;

      getMedia(video)?.classList.remove('is-playing');
    },
    true
  );
}
